import { gql, TypedDocumentNode } from '@common/hooks';
import { FullValidationErrorFragmentType } from '@common/graphql/fragments';

export const UPDATE_STAFFING_REQUEST_MUTATION = gql`
  mutation UpdateStaffingRequest(
    $staffingRequestId: ID!
    $input: UpdateStaffingRequestInput!
    $approvalChainTemplateSource: String
    $deviated: Boolean
  ) {
    updateStaffingRequest(
      staffingRequestId: $staffingRequestId
      input: $input
      approvalChainTemplateSource: $approvalChainTemplateSource
      deviated: $deviated
    ) {
      staffingRequest {
        id
        staffingRequestType
        openStaffingRequestPositionsCount
        startDate
        description
        hoursPerShift
        length
        shiftsPerWeek
        shiftType
        billingRegularRate
        estimatedCost
        yearsOfExperience
        international
        hiringLeader {
          id
          name
        }
        staffingRequestSpecialties {
          id
          necessityLevel
          clinicalSpecialty {
            id
            displayName
          }
        }
        staffingRequestCertifications {
          id
          necessityLevel
          certification {
            id
            credential
            name
          }
        }
        staffingRequestTechnologies {
          id
          technology {
            id
            name
          }
        }
      }
    }
  }
`;

type UpdateStaffingRequestAndApproveStepResponseType = {
  updateStaffingRequestAndApproveStep: {
    staffingRequest: {
      id: string;
      openStaffingRequestPositionsCount: number;
    };
    errors?: FullValidationErrorFragmentType[];
  };
};

type UpdateStaffingRequestAndApproveStepVariablesType = {
  staffingRequestId: string;
  input: {
    openPositions: number;
    approvalNotes?: {
      contentAsText?: string;
    };
  };
};

export const UPDATE_STAFFING_REQUEST_AND_APPROVE_STEP_MUTATION: TypedDocumentNode<
  UpdateStaffingRequestAndApproveStepResponseType,
  UpdateStaffingRequestAndApproveStepVariablesType
> = gql`
  mutation UpdateStaffingRequestAndApproveStep(
    $staffingRequestId: ID!
    $input: UpdateStaffingRequestAndApproveStepInput!
  ) {
    updateStaffingRequestAndApproveStep(
      staffingRequestId: $staffingRequestId
      input: $input
    ) {
      staffingRequest {
        id
        openStaffingRequestPositionsCount
      }
    }
  }
`;
